import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

export const setAssetBackLabel = createAction<string>(addNamespace('util/setAssetBackLabel'));
